//collection page description js

document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(".itg_content-toggle-container");
  if (containers.length > 0) {
    containers.forEach((container) => {
      const btn = container.querySelector(".itg_toggle-content-btn");
      const shortContent = container.querySelector(".short-content");
      const shortContent_extra = document.querySelector(".desc_contain");
      const fullContent = container.querySelector(".full-content");
      if (!btn || !shortContent || !fullContent) {
        console.warn(
          "One or more required elements are missing inside:",
          container
        );
        return;
      }
      btn.addEventListener("click", () => {
        if (
          fullContent.style.maxHeight &&
          fullContent.style.maxHeight !== "0px"
        ) {
          fullContent.style.maxHeight = "0";
          btn.textContent = "Read more";
          shortContent.style.display = "block";
          shortContent_extra.style.display = "block";
        } else {
          fullContent.style.maxHeight = fullContent.scrollHeight + "px";
          btn.textContent = "Read less";
          shortContent.style.display = "none";
          shortContent_extra.style.display = "none";
        }
      });
    });
  }
  

  // Add to cart (main button)
  document.addEventListener("click", function (e) {
    if (e.target.closest(".main_add_cart_btn")) {
      e.preventDefault();
      var button = e.target.closest(".main_add_cart_btn");
      var dataId = button.getAttribute("data-id");
      var data = new URLSearchParams({ id: dataId, quantity: 1 });

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      })
        .then((res) => res.json())
        .then((data) => {
          reloadSection("#Drawer-Cart");
          reloadSection(".desktop_recommendation");
          reloadSection(
            ".mobile_recommendation",
            initMobileRecommendationSlider
          );
        });
    }
  });

  // Add to cart (bundle icon svg)
  document.addEventListener("click", function (e) {
    const svg = e.target.closest(".product_add_btn_bundle svg");
    if (svg) {
      e.preventDefault();
      var dataId = svg.getAttribute("data-id");
      var data = new URLSearchParams({ id: dataId, quantity: 1 });
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      })
        .then((res) => res.json())
        .then((data) => {
          document.querySelector("#itg_header_drawer").click();
          reloadSection("#Drawer-Cart");
          reloadSection(".desktop_recommendation");
          reloadSection(
            ".mobile_recommendation",
            initMobileRecommendationSlider
          );
        })
        .catch((error) => {
          console.error("Error adding item to cart: ", error);
        });
    }
  });

  // Show recommendation options
  document.addEventListener("click", function (e) {
    const cartIcon = e.target.closest(".product_add_btn .itg_carticon");
    if (cartIcon) {
      const container = cartIcon.closest(".itg_main_dr");
      if (!container) return;

      const recommendationOptions = container.querySelector(
        ".recommendation-options"
      );
      const closeIcon = container.querySelector(
        ".product_add_btn .itg_closeicon"
      );
      const mainAddCartBtn = container.querySelector(".main_add_cart_btn");

      if (recommendationOptions && closeIcon && mainAddCartBtn) {
        recommendationOptions.style.display = "block";
        cartIcon.style.display = "none";
        closeIcon.style.display = "inline-block";
        mainAddCartBtn.style.display = "inline-block";
      }
    }
  });

  // Hide recommendation options
  document.addEventListener("click", function (e) {
    const closeIcon = e.target.closest(".product_add_btn .itg_closeicon");
    if (closeIcon) {
      const container = closeIcon.closest(".itg_main_dr");
      if (!container) return;

      const cartIcon = container.querySelector(
        ".product_add_btn .itg_carticon"
      );
      const recommendationOptions = container.querySelector(
        ".recommendation-options"
      );
      const mainAddCartBtn = container.querySelector(".main_add_cart_btn");

      if (cartIcon && recommendationOptions && mainAddCartBtn) {
        cartIcon.style.display = "inline-block";
        closeIcon.style.display = "none";
        recommendationOptions.style.display = "none";
        mainAddCartBtn.style.display = "none";
      }
    }
  });

  // Update data-id on select change
  document.addEventListener("change", function (e) {
    if (e.target.matches(".recommendation-options select.select__select")) {
      const selectedValue = e.target.options[e.target.selectedIndex].value;
      const container = e.target.closest(".itg_main_dr");
      container
        .querySelector(".main_add_cart_btn")
        .setAttribute("data-id", selectedValue);
    }
  });

  if (document.querySelectorAll(".itg_form_control").length > 0) {
    document.querySelectorAll(".itg_form_control").forEach((item) => {
      item.addEventListener("change", () => {
        const selectedOption = item.options[item.selectedIndex];
        const selectedValue = selectedOption.value;
        item
          .closest(".products-bundle__product-wrap")
          .querySelector(".product_add_btn_bundle svg")
          .setAttribute("data-id", selectedValue);
      });
    });
  }

  // Helper function to reload sections
  function reloadSection(selector, callback) {
    fetch(window.location.href)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newContent = doc.querySelector(selector);
        const target = document.querySelector(selector);
        if (newContent && target) {
          target.innerHTML = newContent.innerHTML;
          if (typeof callback === "function") callback();
        }
      });
  }

  // Initialize mobile recommendation slider
  initMobileRecommendationSlider();

  // Terms and conditions validation
  const termsCheckbox = document.querySelector(".cart__terms-checkbox");
  const checkoutButton = document.querySelector(
    ".f-cart-drawer__buttons button, .cart__checkout-button"
  );

  if (termsCheckbox && checkoutButton) {
    termsCheckbox.addEventListener("change", function () {
      checkoutButton.setAttribute(
        "data-terms-required",
        termsCheckbox.checked ? "false" : "true"
      );
    });

    checkoutButton.addEventListener("click", function (event) {
      if (!termsCheckbox.checked) {
        event.preventDefault();
        alert(
          "You must agree with the terms and conditions of sales to check out"
        );
      }
    });
  }


});

//create function for swipper slider mobile
var mobileRecommendationSwiper;

function initMobileRecommendationSlider() {
  if (window.innerWidth < 769) {
    if (
      typeof mobileRecommendationSwiper !== "undefined" &&
      mobileRecommendationSwiper
    ) {
      mobileRecommendationSwiper.destroy(true, true);
      mobileRecommendationSwiper.update(true, true);
    }

    mobileRecommendationSwiper = new Swiper(".mobile-recommendation-swiper", {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".custom-next",
        prevEl: ".custom-prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });
  }
}
document.addEventListener("DOMContentLoaded", () => {
  initMobileRecommendationSlider();
});



window.addEventListener('load', function() {
  var videoSource = document.querySelector("video.lazy-video source");
  if (videoSource) {
    var video_url = videoSource.getAttribute("data-src");
    console.log('video_url:-'+video_url);
    document.querySelectorAll("video.lazy-video source").forEach(function(source) {
      source.setAttribute("src", video_url);
    });
    document.querySelectorAll("video.lazy-video").forEach(function(video) {
      video.load();
    });
  } else {
    //console.error("No video.lazy-video source element found.");
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".collection-description");
  const contentBox = container.querySelector(".content-box");
  const toggleBtn = container.querySelector(".itg_toggle-content-btn");

  let isExpanded = false;

  let collapsedHeight = window.innerWidth <= 768 ? 26 : 35;

  contentBox.style.maxHeight = collapsedHeight + "px";
  container.classList.add("collapsed");

  toggleBtn.addEventListener("click", function () {
    if (!isExpanded) {
      contentBox.style.maxHeight = contentBox.scrollHeight + "px";
      toggleBtn.textContent = "Read less";
    } else {
      contentBox.style.maxHeight = collapsedHeight + "px";
      toggleBtn.textContent = "Read more";
    }
    isExpanded = !isExpanded;
  });

  window.addEventListener("resize", function () {
    if (!isExpanded) {
      collapsedHeight = window.innerWidth <= 768 ? 26 : 35;
      contentBox.style.maxHeight = collapsedHeight + "px";
    }
  });

      var collection_description__fulleventObserversSet = {
          'clickMain': false,
          'clickClose': false
      }

      var collection_description__full_buttonText = {
          'initialValue': '',
          'readLess': 'Read less',
      }

      var collection_description__full = document.getElementsByClassName('collection-description--full'),
          hasWrapClass = 'has-wrap',
          buttonIsVisibleClass = 'js-wrap__buttons--visible',
          toggleButtonOpenClass = 'js-wrap__button--open'

      Array.prototype.forEach.call(collection_description__full, classFieldMainElement => {
          var classFieldContentElement = classFieldMainElement.querySelector('.collection-description__content'),
              classFieldButtonElement = classFieldMainElement.querySelector('.collection-description__buttons');

          collection_description__full432639398_observeJsWrapElements(classFieldMainElement, classFieldContentElement, classFieldButtonElement);
      });

      window.addEventListener('resize', () => {
          Array.prototype.forEach.call(collection_description__full, classFieldMainElement => {
              var classFieldContentElement = classFieldMainElement.querySelector('.collection-description__content'),
                  classFieldButtonElement = classFieldMainElement.querySelector('.collection-description__buttons');

              collection_description__full432639398_observeJsWrapElements(classFieldMainElement, classFieldContentElement, classFieldButtonElement);
          });
      });

      function collection_description__full432639398_observeJsWrapElements(classFieldMainElement, classFieldContentElement, classFieldButtonElement) {
          if (!classFieldContentElement) {
              return;
          }
          // Handle show / hide
          var maxContentHeight = parseInt(classFieldContentElement.clientHeight),
              realContentHeight = parseInt(classFieldContentElement.scrollHeight);

          var childButton = classFieldButtonElement.querySelector('.js-wrap__button');

          // Determine if button needs to be shown
          if (maxContentHeight < realContentHeight) {
              classFieldButtonElement.classList.add(buttonIsVisibleClass);
              classFieldContentElement.classList.add(hasWrapClass);
          } else {
              if (!classFieldMainElement.classList.contains('is-expanded')) {
                  classFieldButtonElement.classList.remove(buttonIsVisibleClass);
                  classFieldContentElement.classList.remove(hasWrapClass);
              }
          }

          // Handle button click
          if (!collection_description__fulleventObserversSet.clickMain) {
              collection_description__fulleventObserversSet.clickMain = true;

              classFieldButtonElement.addEventListener('click', (e) => {
                                      if (window.innerWidth >= 1024) {
                      toggleExpand(classFieldMainElement, childButton);
                  } else {
                      toggleExpand(classFieldMainElement, childButton);
                  }
                                  });
          }

                      if (window.innerWidth <= 1024) {
              toggleExpand(classFieldMainElement, childButton, true);
          }
          
          setTimeout(function(){
              const closeButtons = document.getElementsByClassName("js-overlay__toggle--close");

              for (let i = 0; i < closeButtons.length; i++) {
                  if (!collection_description__fulleventObserversSet.clickClose) {
                      closeButtons[i].addEventListener("click", function () {
                          childButton.classList.remove(toggleButtonOpenClass);
                          document.querySelector('.js-panel__title > span').innerHTML = "";
                          document.querySelector('.js-panel__content').innerHTML = "";
                      });

                      collection_description__fulleventObserversSet.clickClose = true;
                  }
              }
          }, 50);
      }

      function toggleExpand(classFieldMainElement, childButton, hide = false)
      {
          let initialValue = collection_description__full_buttonText.initialValue;
          let readLess = collection_description__full_buttonText.readLess;

          if (!initialValue) {
              collection_description__full_buttonText.initialValue = initialValue = childButton.innerHTML;
          }

          if (hide == true) {
              classFieldMainElement.classList.remove('is-expanded');
          } else {
              classFieldMainElement.classList.toggle('is-expanded');
          }

          if (classFieldMainElement.classList.contains('is-expanded')) {
              
              childButton.querySelector('span').innerHTML = collection_description__full_buttonText.readLess;
          } else {
              childButton.innerHTML = initialValue;
          }
      }

      function togglePanel(classFieldButtonElement, childButton, classFieldContentElement)
      {
          let content = classFieldContentElement.innerHTML;

          window.hypr.overlay.open(null, null, content, HYPR_OVERLAY_TYPE.Slide)
      }
});


